import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {IMetaEventOutgoing} from "./IMetaEventOutgoing";
import {EntityService} from "../../entity/EntityService";
import {config} from "../../../config";

export class MetaAdsService {

    public static async sendEvent(event: IMetaEventOutgoing, siteId?: string): Promise<void> {
        const url = this.buildUrl(`/site/signal`, siteId);
        await Network.postJson(ProductType.PANEL, url, event);
    }

    public static async sendEventBatch(events: IMetaEventOutgoing[], siteId?: string): Promise<void> {
        if (events.length === 0) return;
        const url = this.buildUrl(`/site/signal/batch`, siteId);
        await Network.postJson(ProductType.PANEL, url, events);
    }

    public static sendEventBatchBeacon(events: IMetaEventOutgoing[], siteId?: string): boolean {
        if (events.length === 0) return true;
        const url = this.buildUrl(`/site/signal/batch`, siteId);
        const fullUrl = `${config.httpPanelUrl}${url}`;
        const blob = new Blob([JSON.stringify(events)], {type: 'application/json'});
        return navigator.sendBeacon(fullUrl, blob);
    }

    private static buildUrl(basePath: string, siteId?: string): string {
        const authenticated = !!EntityService.activeEntities?.length;
        const path = authenticated ? `${basePath}/account` : basePath;
        return siteId ? `${path}?siteId=${siteId}` : path;
    }
}
